module.exports = __webpack_public_path__ + "static/media/mute_icon_grey.10f1622a.svg";